<template>
    <section class="v-section">
        <slot></slot>
        <div v-if="onScrollEnd != undefined" class="observer" v-observer="onScrollEnd"></div>
    </section>
</template>

<script>

export default {
    name: 'v-section',
    props: {
        onScrollEnd: {
            type: Function,
            default: undefined
        }
    },
    data: () => ({
        // @ts-ignore
        observer: null
    }),
}

</script>

<style lang="scss">

.v-section {
    @apply px-12 py-5 flex-grow overflow-y-auto border-[10px] border-l-0 border-transparent;

    scroll-behavior: smooth;
}

.observer {
    @apply w-full opacity-0 pointer-events-none;
}

</style>